module.exports = __webpack_public_path__ + "static/media/jamkrindo.18d821ae.png";